import React from 'react';
import createReactClass from 'create-react-class';

import { track, EVENTS } from '../lib/tracking';

// import media from '../metadata/components/assets/Controller'
import categories from '../metadata/components/RouteInterface'
import encoders from '../metadata/components/RouteInterface'
import keywords from '../metadata/components/RouteInterface'
import locations from '../metadata/components/RouteInterface'
import technicians from '../metadata/components/RouteInterface'
import listing from '../embed/ManagerRouteInterface'
import player from '../embed/ManagerRouteInterface'

export default function (api, socket, opts, match) {
    var credentials = opts.credentials;
    var params = match.params;

    var domains = {
        // media: media.bind(null, api.assets, socket),
        categories: categories.bind(null, 'categories', api.categories, socket),
        encoders: encoders.bind(null, 'encoders', api.encoders, socket),
        keywords: keywords.bind(null, 'keywords', api.keywords, socket),
        locations: locations.bind(null, 'locations', api.locations, socket),
        technicians: technicians.bind(null, 'technicians', api.technicians, socket),
        listing: listing.bind(null, 'listing', api.channels, credentials),
        player: player.bind(null, 'player', api.player, credentials)
    };
    var View = domains[params.domain]();

    return createReactClass({
        componentDidMount: function () {
            track(EVENTS.MANAGE_OPEN, { domain: params.domain });
        },
        render: function () {
            return <View {...this.props} credentials={credentials} mode="manage" />;
        }
    });
};
